import { promise } from '../../../helpers';

const validateOnSaveExamSubmission = () => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        return promise({ success: true });
    };
};

export default validateOnSaveExamSubmission;
